import $ from 'jquery'

function getValuesFromQueryString(queryParameterValues) {
    if (!queryParameterValues) {
        return {};
    }

    let queryParameters = {},
        parameterValues;

    queryParameterValues = (queryParameterValues[0] === '?' ? queryParameterValues.substr(1) : queryParameterValues).split('&');

    queryParameterValues.forEach(queryParameterValue => {
            if (queryParameterValue) {
                parameterValues = queryParameterValue.split('=');
                queryParameters[decodeURIComponent(parameterValues[0])] = decodeURIComponent(parameterValues[1] || "");
            }
        }
    );

    return queryParameters;
}

/**
 * Returns a map of query parameters as key value.
 * Given defaults will be combined with the url's query string parameters.
 * Note: duplicate keys are not supported (previous values will be overwritten).
 */
export function getQueryParameters(defaultQueryString) {
    return $.extend({},
        getValuesFromQueryString(defaultQueryString),
        getValuesFromQueryString(window.location.search)
    );
}

/**
 * Get fragment value in given url or current web url.
 * Example: Url 'foo#bar' returns the value 'bar'.
 */
export function getFragmentValue(url) {
    url = url || location.hash;
    return url.split("#")[1]
}
